module.exports = __webpack_public_path__ + "img/RCT12.5662624f.svg";